module.exports = __webpack_public_path__ + "static/media/angieveguilla-7.9555c2a2.jpg";